import { makeStyles } from '../../../../../../styles';
import { VIEWS_MENU_MIN_WIDTH } from '../../ViewsMenu.styles';
const ACTIONS_PANEL_WIDTH = 102;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1),
        minHeight: theme.spacing(8),
        '&.active': {
            cursor: 'default',
            '&:hover': {
                backgroundColor: theme.colors.primary.contrastWhite,
            },
        },
        '&.disabled': {
            cursor: 'default',
            '&:hover': {
                backgroundColor: theme.colors.primary.contrastWhite,
            },
        },
        '&.openingDisallowed': {
            cursor: 'not-allowed',
        },
    },
    leftColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    rightColumn: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    viewName: {
        color: theme.colors.text[900],
        maxWidth: `calc(${VIEWS_MENU_MIN_WIDTH}px - ${ACTIONS_PANEL_WIDTH}px - ${theme.spacing(2)})`,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 600,
        '&.active': {
            color: theme.colors.primary.main,
        },
        '&.isEditModeActive': {
            maxWidth: VIEWS_MENU_MIN_WIDTH,
        },
    },
    viewCreatedBy: Object.assign(Object.assign({}, theme.typography.body2), { color: theme.colors.text[600] }),
    panel: {
        display: 'flex',
    },
    panelIconButton: {
        borderRadius: '100%',
    },
    panelIcon: {
        height: theme.spacing(2),
        width: theme.spacing(2),
        color: theme.colors.text[700],
    },
    deleteContainer: {
        display: 'flex',
        gap: theme.spacing(0.5),
    },
    editContainer: {
        flex: 1,
        display: 'flex',
        gap: theme.spacing(0.5),
        alignItems: 'flex-start',
        '& .MuiTextField-root': {
            width: '100%',
        },
    },
    pinIcon: {
        marginRight: theme.spacing(1),
        height: theme.spacing(2),
        width: theme.spacing(2),
        color: theme.colors.primary.main,
    },
}));
export default useStyles;
//# sourceMappingURL=CustomView.styles.js.map